import React, { FC } from 'react';
import { faStar } from '@fortawesome/free-solid-svg-icons/faStar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import NavigationUserInfoSection from 'buyside/components/presentation/MainSiteNavigation/TopNavigation/NavigationUser/NavigationUserInfo/navigationUserInfoSection';

import { rankingUrl } from 'buyside/util/urlHelper';

import { NavigationUserInfoQuery } from 'interfaces/graphql-typings';

import styles from '../navigationUserInfoStyles.scss';

const UserRanking: FC<{
  featuredRank: NonNullable<NonNullable<NavigationUserInfoQuery['currentUser']>['featuredRank']>;
}> = ({ featuredRank }) => {
  let rankContent = (
    <a className={styles.userRankingContent} href={rankingUrl(featuredRank.category)}>
      <FontAwesomeIcon icon={faStar} />
      <strong>{featuredRank.rankString}</strong>
    </a>
  );

  if (!featuredRank.current) {
    rankContent = (
      <div className={styles.userRankingContent}>
        <FontAwesomeIcon icon={faStar} />
        <strong>{featuredRank.rankString}</strong>
      </div>
    );
  }

  return (
    <NavigationUserInfoSection
      title={`Your ${featuredRank.current ? 'Current Ranking' : 'Most Recent Ranking'}`}
    >
      {rankContent}
    </NavigationUserInfoSection>
  );
};

export default UserRanking;
